// Port of api/fuel/app/classes/controller/api/monty/views/create.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import Util from 'offline/util'

var DEFAULT_FIELDS = {
	'1:1': [
		{ id: 'fd445cbacda122d9dcc7fc96fd8d7c58', type: 'insight.game', locked: 0, label: 'Game', width: '', sticky: 0, devices: 0, sorts: [], filters: [], version: 'enabled', tags: 'enabled', awards: 'disabled' }
	],
	'1:2': [
		{ id: 'fd445cbacda122d9dcc7fc96fd8d7c58', type: 'insight.rating', locked: 0, label: 'Game', width: '', sticky: 0, devices: 0, sorts: [], filters: [], status: 'enabled', date: 'enabled', comment: 'enabled', tags: 'enabled' }
	],
	'1:3': [
		{ id: 'fd445cbacda122d9dcc7fc96fd8d7c58', type: 'insight.play', locked: 0, label: 'Game', width: '', sticky: 0, devices: 0, sorts: [], filters: [], status: 'enabled', date: 'disabled', location: 'enabled', duration: 'disabled', count: 'disabled', players: 'disabled', tags: 'enabled', report: 'enabled' }
	],
	'1:4': [
		{ id: 'fd445cbacda122d9dcc7fc96fd8d7c58', type: 'insight.game', locked: 0, label: 'Game', width: '', sticky: 0, devices: 0, sorts: [], filters: [], version: 'disabled', tags: 'enabled', awards: 'disabled' }
	],
	'2:0': [
		{ id: '0a4dcaf73df0875e15dad4636ac12e5e', type: 'game.name', locked: 0, label: 'Game', width: '', sticky: 0, devices: 0, sorts: [], filters: [] }
	],
	'3:1': [
		{ id: '0a4dcaf73df0875e15dad4636ac12e5e', type: 'insight.card', locked: 1, label: '', width: '', sticky: 0, devices: 0, sorts: [], filters: [], bgg_rating: 'enabled', user_rating: 'enabled' },
		{ id: 'fd445cbacda122d9dcc7fc96fd8d7c58', type: 'insight.game', locked: 1, label: '', width: 'default', sticky: 0, devices: 0, sorts: [], filters: [], version: 'enabled', tags: 'enabled', awards: 'disabled' }
	],
	'3:2': [
		{ id: '0a4dcaf73df0875e15dad4636ac12e5e', type: 'insight.card', locked: 1, label: '', width: '', sticky: 0, devices: 0, sorts: [], filters: [], bgg_rating: 'disabled', user_rating: 'enabled' },
		{ id: 'fd445cbacda122d9dcc7fc96fd8d7c58', type: 'insight.rating', locked: 1, label: '', width: 'default', sticky: 0, devices: 0, sorts: [], filters: [], status: 'enabled', date: 'enabled', comment: 'enabled', tags: 'enabled' }
	],
	'3:3': [
		{ id: '0a4dcaf73df0875e15dad4636ac12e5e', type: 'insight.card', locked: 1, label: '', width: '', sticky: 0, devices: 0, sorts: [], filters: [], bgg_rating: 'disabled', user_rating: 'disabled' },
		{ id: 'fd445cbacda122d9dcc7fc96fd8d7c58', type: 'insight.play', locked: 1, label: '', width: 'default', sticky: 0, devices: 0, sorts: [], filters: [], status: 'enabled', date: 'enabled', location: 'enabled', duration: 'enabled', count: 'enabled', players: 'enabled', tags: 'enabled' }
	],
	'3:4': [
		{ id: '0a4dcaf73df0875e15dad4636ac12e5e', type: 'insight.card', locked: 1, label: '', width: '', sticky: 0, devices: 0, sorts: [], filters: [], bgg_rating: 'disabled', user_rating: 'disabled' },
		{ id: 'fd445cbacda122d9dcc7fc96fd8d7c58', type: 'insight.game', locked: 1, label: '', width: 'default', sticky: 0, devices: 0, sorts: [], filters: [], version: 'disabled', tags: 'enabled', awards: 'enabled' }
	],
	'4:1': [
		{ id: '0a4dcaf73df0875e15dad4636ac12e5e', type: 'box.art', locked: 1, label: '', width: '', sticky: 0, devices: 0, sorts: [], filters: [], size: 'natural' },
		{ id: 'fd445cbacda122d9dcc7fc96fd8d7c58', type: 'insight.game', locked: 1, label: 'Game', width: '', sticky: 0, devices: 0, sorts: [], filters: [], version: 'enabled', tags: 'enabled', awards: 'disabled' }
	],
	'4:2': [
		{ id: '0a4dcaf73df0875e15dad4636ac12e5e', type: 'box.art', locked: 1, label: '', width: '', sticky: 0, devices: 0, sorts: [], filters: [], size: 'natural', rating: 'disabled' },
		{ id: 'fd445cbacda122d9dcc7fc96fd8d7c58', type: 'insight.rating', locked: 1, label: 'Game', width: '', sticky: 0, devices: 0, sorts: [], filters: [], status: 'enabled', date: 'enabled', comment: 'enabled', tags: 'enabled' }
	],
	'4:3': [
		{ id: '0a4dcaf73df0875e15dad4636ac12e5e', type: 'box.art', locked: 1, label: '', width: '', sticky: 0, devices: 0, sorts: [], filters: [], size: 'natural', rating: 'disabled', date: 'enabled' },
		{ id: 'fd445cbacda122d9dcc7fc96fd8d7c58', type: 'insight.play', locked: 0, label: 'Game', width: '', sticky: 0, devices: 0, sorts: [], filters: [], status: 'enabled', date: 'disabled', location: 'disabled', duration: 'disabled', count: 'disabled', players: 'disabled', tags: 'disabled' }
	],
	'4:4': [
		{ id: '0a4dcaf73df0875e15dad4636ac12e5e', type: 'box.art', locked: 1, label: '', width: '', sticky: 0, devices: 0, sorts: [], filters: [], size: 'natural', plays: 'enabled' },
		{ id: 'fd445cbacda122d9dcc7fc96fd8d7c58', type: 'insight.game', locked: 1, label: 'Game', width: '', sticky: 0, devices: 0, sorts: [], filters: [], version: 'disabled', tags: 'enabled', awards: 'disabled' }
	]
}

function clone(value) {
	return JSON.parse(JSON.stringify(value))
}

function viewToArray(row) {
	var fields = row.view_fields || []
	if (typeof fields === 'string') {
		try { fields = JSON.parse(fields) } catch (e) { fields = [] }
	}
	return {
		id: parseInt(row.view_id, 10) || 0,
		default: parseInt(row.view_default, 10) || 0,
		type: parseInt(row.view_type, 10) || 0,
		context: parseInt(row.view_context, 10) || 0,
		public: parseInt(row.view_public, 10) || 0,
		name: row.view_name,
		fields: fields
	}
}

export default function(params) {
	var userId = params.sessionUserId || DB.meta('sync_user_id') || false
	var data = params.data || {}
	var name = String(data.name || '').trim()
	var type = parseInt(data.type, 10) || 0
	var context = parseInt(data.context, 10) || 0
	var key = type + ':' + context
	var fields = clone(DEFAULT_FIELDS[key] || [])

	if (!userId) {
		return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
	}

	if (!name || type < 1 || type > 4 || context < 0 || context > 4 || !fields.length) {
		return Promise.reject({ error: Constants.API_ERROR_INVALID, offline: true })
	}

	DB.run('INSERT INTO view (user_id, group_id, buddies_id, view_default, view_type, view_context, view_public, view_name, view_slug, view_fields) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)', [
		userId,
		0,
		0,
		0,
		type,
		context,
		parseInt(data.public, 10) || 0,
		name,
		Util.slug(name),
		JSON.stringify(fields)
	])

	var id = DB.scalar('SELECT last_insert_rowid()')
	var rows = DB.query('SELECT * FROM view WHERE view_id = ?', [id])

	return DB.save().then(function() {
		return {
			session: { offline: true },
			data: viewToArray(rows[0])
		}
	})
}
